import React from 'react';

import { observer } from 'mobx-react';

import { SidebarItem } from '../SidebarItem/SidebarItem';
import { useIsActivePage } from '../../../../hooks/useIsActivePage';
import { PATH_TYPE } from '../../../../constants/system/headerSettings';
import { SidebarLinkItem } from '../../../../interfaces/system/SidebarNavConfig';
import { getNavigationIcon } from '../../../../utils/navigationUtils/getNavigationIcon/getNavigationIcon';
import { useBadgeValue } from './hooks/useBadgeValue';
import { useSidebarContext } from '../../hooks/SidebarContext';

type SidebarNavLinkProps = {
  item: SidebarLinkItem;
  onClick?: () => void;
};

const SidebarNavLink = observer(({ item, onClick }: SidebarNavLinkProps) => {
  const { label, path, pathType, icon, badgeKey } = item;

  const { isCollapsed } = useSidebarContext();
  const badgeValue = useBadgeValue({ badgeKey });

  const isActive = useIsActivePage({ url: path });

  const isExternal = pathType === PATH_TYPE.EXTERNAL_LINK;
  const href = isExternal ? path : `#!${path}`;
  const target = isExternal ? '_blank' : undefined;

  return (
    <SidebarItem
      as="a"
      href={href}
      target={target}
      onClick={onClick}
      startIcon={getNavigationIcon(icon)}
      label={label}
      active={!!isActive}
      activeHighlight
      badgeValue={badgeValue}
      collapsed={isCollapsed}
    />
  );
});

export { SidebarNavLink };
